export const TUTOR_BUILDER_LIMITS = {
  goal: 500,
  audience: 240,
  sourceText: 10_000,
  greeting: 500,
  correctionStyle: 120,
} as const;
